import React from 'react';
import { fetchInTimeOptionEnd, fetchInTimeOptionStart } from '../../../../businessLogic/operatingDaysAndHours';

export default function CenterPanelView(props) {
  const getDayNames = ({
    isMondaySelected,
    isTuesdaySelected,
    isWednesdaySelected,
    isThursdaySelected,
    isFridaySelected,
    isSaturdaySelected,
    isSundaySelected,
  }) => {
    let dayNames = [];

    isMondaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.MondayText) : '';
    isTuesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.TuesdayText) : '';
    isWednesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.WednesdayText) : '';
    isThursdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.ThursdayText) : '';
    isFridaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.FridayText) : '';
    isSaturdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.SaturdayText) : '';
    isSundaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.SundayText) : '';
    return dayNames.join(', ');
  };
  const getShortDayNames = ({
    isMondaySelected,
    isTuesdaySelected,
    isWednesdaySelected,
    isThursdaySelected,
    isFridaySelected,
    isSaturdaySelected,
    isSundaySelected,
  }) => {
    let dayNames = [];

    isMondaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.MondayShort) : '';
    isTuesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.TuesdayShort) : '';
    isWednesdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.WednesdayShort) : '';
    isThursdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.ThursdayShort) : '';
    isFridaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.FridayShort) : '';
    isSaturdaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.SaturdayShort) : '';
    isSundaySelected ? dayNames.push(APP.LANGUAGE.WaitingAreaLocalAccessHours.SundayShort) : '';
    return dayNames.join(', ');
  };

  let serviceAvailibilty = props.waitingAreaLocalAccessHoursForm.serviceOfferingAvailabilities.map((option, i) => {
    return (
      <div className="mrbs">
        <div>{fetchInTimeOptionStart(option.fromTime) + ' to ' + fetchInTimeOptionEnd(option.toTime)}</div>
        <div className="hide-on-small-ress">{getDayNames(option)}</div>
        <div className="show-on-small-ress ">{getShortDayNames(option)}</div>
      </div>
    );
  });

  return (
    <span>
      <div className="ui form">
        <div data-show={!props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}>
          <div className="word-break">{APP.LANGUAGE.WaitingAreaLocalAccessHours.LocalAccessNotAvailable}</div>
        </div>
        <div data-show={props.waitingAreaLocalAccessHoursForm.limitedByLocalTime}>
          <div className="word-break">
            {APP.LANGUAGE.WaitingAreaLocalAccessHours.WaitingAreaLocalAccessAvailaibility}
          </div>
          <div className="mrts">
            <div className="mrls word-break">{serviceAvailibilty}</div>
          </div>
        </div>
      </div>
      <div className="mrbs hide-on-small-ress " />
    </span>
  );
}
